export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 110,
    fixed: 'left',
    slots: {
      default: 'opt',
    },
  },
  {
    headerAlign: 'center',
    field: 'vehicleNo',
    align: 'center',
    minWidth: 120,
    title: '车牌号',
    fixed: 'left',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleVolume',
    align: 'center',
    minWidth: 120,
    title: '体积m³',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLoad',
    align: 'center',
    minWidth: 120,
    title: '载重kg',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleModel',
    align: 'center',
    minWidth: 120,
    title: '车型',
    sortable: true,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLength',
    align: 'center',
    minWidth: 120,
    title: '车长（米）',
    sortable: true,
    sortType: 'number',
    slots: {
      default: 'vehicleLengthDefault',
    },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleOwnerType',
    align: 'center',
    minWidth: 100,
    title: '车辆归属',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleBrand',
    align: 'left',
    minWidth: 120,
    title: '车辆品牌',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicense',
    align: 'left',
    minWidth: 250,
    title: '车辆行驶证号',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleInspectionStatus',
    align: 'center',
    minWidth: 100,
    title: '车辆审核状态',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'vehicleLicenseValidity',
    align: 'center',
    minWidth: 120,
    title: '车辆行驶证有效期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'purchaseDate',
    align: 'center',
    minWidth: 120,
    title: '购车日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'registrationDate',
    align: 'center',
    minWidth: 120,
    title: '上牌日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'insuranceDate',
    align: 'center',
    minWidth: 120,
    title: '保险到期日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'inspectionDate',
    align: 'center',
    minWidth: 120,
    title: '年检到期日期',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'orgName',
    align: 'left',
    minWidth: 250,
    title: '登记机构',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'carrierName',
    align: 'left',
    minWidth: 200,
    title: '所属承运商',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'vehicleRemarks',
    align: 'left',
    minWidth: 300,
    title: '备注信息',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'vehicleStatusName',
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
  },
  {
    headerAlign: 'center',
    field: 'dataSourceName',
    align: 'center',
    width: 80,
    title: '数据来源',
  },
  {
    headerAlign: 'center',
    field: 'createByName',
    title: '创建人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'createTime',
    title: '创建时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },
  {
    headerAlign: 'center',
    field: 'modifyByName',
    title: '修改人',
    width: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    headerAlign: 'center',
    field: 'modifyTime',
    title: '修改时间',
    width: 170,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
    sortable: true,
  },

]
